import { IFile } from 'src/typings/viewConfig';

export const BuildFileLink = (file: IFile): string => {
  return `https://${file.domain}${file.path}${file.name}.${file.extension}`;
};
